import * as actionTypes from "../actionTypes";
import Axios from "../../../services/NetworkService";

// Action to fetch latest radar clusters
export const radarClustersLatest = (catchmentId = null) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.RADAR_CLUSTERS_INIT });

    try {
      // Use test data from radar_clusters_contours.geojson
      const response = await fetch('/data/radar_clusters_contours.geojson');
      const testData = await response.json();
      
      // Filter clusters based on catchmentId if provided
      let filteredData = testData;
      if (catchmentId) {
        filteredData = testData.filter(cluster => {
          const clusterCatchmentId = cluster?.metadata?.catchment_id;
          if (!clusterCatchmentId) return false;
          // Extract AGS prefix from catchment_id (e.g., "09572132" from "09572132_1")
          const agsPrefix = clusterCatchmentId.split("_")[0];
          return agsPrefix === catchmentId;
        });
      }
      
      dispatch({
        type: actionTypes.RADAR_CLUSTERS_SUCCESS,
        payload: filteredData,
      });
      
      // Auto-activate radar clusters if there are clusters available for this catchment
      if (filteredData.length > 0) {
        dispatch({
          type: actionTypes.RADAR_CLUSTERS_TOGGLE,
          payload: true,
        });
      }
      
    } catch (error) {
      console.error('Failed to load radar clusters test data:', error);
      
      // Fallback to API call if test data fails
      try {
        const token = localStorage.getItem("token");
        const url = `/radar-clusters/latest`;
        
        const params = {};
        if (catchmentId) {
          params.catchmentId = catchmentId;
        }

        // Use the NetworkService Axios which handles authentication properly
        const apiResponse = await Axios.get(url, { params });
        
        dispatch({
          type: actionTypes.RADAR_CLUSTERS_SUCCESS,
          payload: apiResponse.data,
        });
        
                 // Auto-activate radar clusters if there are clusters available
         if (apiResponse.data && apiResponse.data.length > 0) {
           dispatch({
             type: actionTypes.RADAR_CLUSTERS_TOGGLE,
             payload: true,
           });
         }
        
      } catch (apiError) {
        console.error('API call also failed:', apiError);
        dispatch({
          type: actionTypes.RADAR_CLUSTERS_FAIL,
          payload: apiError.message,
        });
      }
    }
  };
};

// Action to fetch radar clusters by time range
export const radarClustersByTimeRange = (startTime, endTime, catchmentId = null) => {
  return async (dispatch) => {
    dispatch({ type: actionTypes.RADAR_CLUSTERS_INIT });

    try {
      const url = `/radar-clusters/time-range`;
      
      const params = {
        startTime,
        endTime
      };
      
      if (catchmentId) {
        params.catchmentId = catchmentId;
      }

      // Use the NetworkService Axios which handles authentication properly
      const response = await Axios.get(url, { params });
      
      dispatch({
        type: actionTypes.RADAR_CLUSTERS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: actionTypes.RADAR_CLUSTERS_FAIL,
        payload: error.message,
      });
    }
  };
};

// Action to toggle radar clusters visibility
export const toggleRadarClusters = (isVisible) => {
  return {
    type: actionTypes.RADAR_CLUSTERS_TOGGLE,
    payload: isVisible,
  };
};

export const radarClustersInit = () => {
  return {
    type: actionTypes.RADAR_CLUSTERS_INIT,
  };
};

export const radarClustersSuccess = (data) => {
  return {
    type: actionTypes.RADAR_CLUSTERS_SUCCESS,
    payload: data,
  };
};

export const radarClustersFail = (error) => {
  return {
    type: actionTypes.RADAR_CLUSTERS_FAIL,
    payload: error,
  };
};

export const getRadarClusters = () => {
  return (dispatch, getState) => {
    const state = getState();
    const token = state.auth.token;
    const userId = state.auth.userId;

    if (!token || !userId) {
      console.warn("No authentication token or user ID available for radar clusters request");
      return Promise.resolve();
    }

    dispatch(radarClustersInit());

    const url = `/api/radar-clusters?user_id=${userId}`;

    return Axios.get(url)
      .then((response) => {
        if (response && response.data && Array.isArray(response.data)) {
          dispatch(radarClustersSuccess(response.data));
          return response.data;
        } else {
          console.warn("Invalid radar clusters response format:", response);
          dispatch(radarClustersSuccess([]));
          return [];
        }
      })
      .catch((error) => {
        console.error("Error fetching radar clusters:", error);
        dispatch(radarClustersFail(error.message || "Failed to fetch radar clusters"));
        return [];
      });
  };
}; 